/*
  <Tag
    to=""     // if not set, will do nothing on click
  >
    Text      // if "Text" not set, will not render the component
  </Tag>
*/
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Tag = ({ to, children, ...rest }) => {
  const history = useHistory();
  const routeChange = ({ to }) => history.push(to);
  if (!children) return "";
  if (to)
    return (
      <Link to={to} {...rest}>
        <TagStyle>{children}</TagStyle>
      </Link>
    );
  return <TagStyle onClick={routeChange}>{children}</TagStyle>;
};
export default Tag;

// Styling
const TagStyle = styled.span`
  font-family: "Poppins Medium";
  font-weight: 600;
  font-size: 10px;
  display: inline-block;
  line-height: 72%;
  letter-spacing: 0.02em;
  border-radius: 50px;
  padding: 3px 7px;
  color: ${({ theme }) => theme.color.secondaryIcon};
  background-color: ${({ theme }) => theme.color.secondaryBg};
  cursor: pointer;
  user-select: none;
  margin-right: 4px;
  white-space: nowrap;
  transition: color 200ms, background-color 200ms;

  :hover {
    transition: color 200ms, background-color 200ms;
    color: ${({ theme }) => theme.color.primary};
    background-color: ${({ theme }) => theme.color.white};
  }
  &:focus,
  &:active {
    box-shadow: 0 0 0 0.2rem rgba(69, 105, 255, 0.5);
  }
  :last-child {
    margin-right: 0;
  }
`;
